import { useQuery } from "@apollo/client";

import Drive from "@components/drive/Drive";
import HandleQuery from "@components/HandleQuery";
import DriveLoader from "@components/loaders/DriveLoader";
import ClientPage from "@components/pageTypes/ClientPage";
import useSubscribeToJourney from "@hooks/subscriptions/useSubscribeToJourney";
import {
  GetJourneyWithDocumentsDocument,
  GetJourneyWithDocumentsQuery,
  GetJourneyWithDocumentsQueryVariables
} from "@typing/Generated";

type Props = {
  journeyId: string;
};

const ExpertJourneyDrivePage = ({ journeyId }: Props) => {
  const getJourneyWithDocumentsQuery = useQuery<GetJourneyWithDocumentsQuery, GetJourneyWithDocumentsQueryVariables>(
    GetJourneyWithDocumentsDocument,
    {
      variables: {
        id: journeyId
      }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getJourneyWithDocumentsQuery.refetch();
  });

  return (
    <ClientPage helmetKey="pageTitles.client.drive.list" journeyId={journeyId}>
      <HandleQuery loadingContent={<DriveLoader />} query={getJourneyWithDocumentsQuery}>
        {data => <Drive journey={data.journey} />}
      </HandleQuery>
    </ClientPage>
  );
};

export default ExpertJourneyDrivePage;
